import { render, staticRenderFns } from "./ClinicItemNew.vue?vue&type=template&id=3eeedb2f"
import script from "./ClinicItemNew.vue?vue&type=script&lang=js"
export * from "./ClinicItemNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports